import {createContext} from 'react';

export const SettlementsContext = createContext();